//Menú principal del landing page

//Imports 
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.css';
import { Modal, Button, Divider } from 'antd';
import warningLogo from './img/warning.png';

//HTML DEL COMPONENTE 
function NotAllowed() {

    const okStyle = { style: { background: '#5A6978' } };

    return (
        <div>
            <Modal visible={true} width={700} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                <img src={warningLogo} style={{height: '10%', width: '10%'}}></img>
                <h1 style={{fontWeight: 'bold'}}>¡Lo Sentimos!</h1>
                <h3>Usted no tiene los permisos necesarios para acceder a esta cuenta.</h3>
                <Divider style={{background: '#969FAA'}}/>
                <Button style={{background: '#5A6978', color: 'white'}} id="Logout">SALIR</Button>
            </Modal>
        </div>
    );
}

export default NotAllowed;